<template>
    <div class="about_menu_top  textalign_left">
        <div style="background: #fff;max-width: 1920px;margin: 0 auto;"  class="ms-controller">
            <div style="margin: 0 auto;">
                <div style="height: 9247px;background: url('https://p1.fishqc.net/Fka-WmKK_zh6gsvrBodTNBo2wAhe') center center no-repeat;background-size: auto 100%;padding-top: 572px;box-sizing: border-box;">
                    <div class="contain_2022_315" style="width:1056px;margin:0 auto;display:block;position: relative;font-size:36px;font-family:PingFang SC;color:533727;text-align: center;">
                        <div class="title_618">一年一度的“618”大促来了，你准备好“剁手”了吗?小鱼优品大盘点，科学测评让你“剁手”不再迷茫！</div>

                        <div v-for="val in productdata" :class="val.paddingtop">
                            <div class="position_relative">
                                <div :class="val.bgicon"></div>
                                <div class="top_box">
                                    <div class="top_box_title"><div class="title">{{val.title}}</div></div>
                                    <div class="top_box_desc">{{val.dec}}</div>
                                </div>
                                
                            </div>
                            <div class="textalign_left">
                                <div v-for="value in val.dd" class="margin_top_32">
                                    <div class="itemtitle">{{value.title}}</div>
                                    <div class="subbox">
                                        {{value.destext}}
                                    </div>
                                    <div>
                                        <div class="display_flex justify-content_flex-justify padding_top_24">
                                        <div v-for="productItem in value.product" class="productbox_315 display_flex justify-content_flex-justify" :class="[productItem.boxbgColor,productItem.highheight]" @click="toproductdetail(productItem.type,productItem.id)" >
                                            <div class="productImg" >
                                                <img :src="productItem.img" class="center">
                                                <!-- <div class="productimage" :style="{backgroundImage: 'url('+ productItem.img + ')'}"></div> -->
                                                <div>
                                                    <img src="https://p1.fishqc.net/FsSAn-Hj02ROZMg-VwKL3MUXat5I" class="greenIcon">
                                                </div>
                                            </div>
                                            <div style="text-align: left;flex:1;padding-bottom: 42px;box-sizing: border-box;" class="display_flex justify-content_flex-justify derection-column">
                                                <div>
                                                    <div class="brand_315" :class="{'lineheight1':productItem.brandshow}" v-html="productItem.brand"></div>
                                                    <div class="producttitle_315" :class="{'lineheight2':productItem.titleshow}" v-html="productItem.title"></div>
                                                  
                                                </div>
                                                <div>
                                                    <div class="tips_315">
                                                        <div class="tips_text">{{productItem.tips}}</div>
                                                    </div>
                                                    <div class="address_315">品牌所在地：{{productItem.address}}</div>
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                       
                    </div>
                    <div style="padding-top:300px;box-sizing: border-box;text-align: center;">
                        <img src="https://p1.fishqc.net/FrITjy_zoZj6s45kSPzia0J93DMe" alt="">
                    </div>
                    <div style="padding-top:190px;box-sizing: border-box;text-align: center;">
                        <img src="https://p1.fishqc.net/FvjpC-79KN7mQh9z4lZJZ-X6xPw4" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
.about_menu_top {
    margin: 100px auto 0;

}
.fangyicontain {
    font-size: 0;
}

.mumcontain{
    width: 1054px;
    margin:0 auto;
    display: block;
    text-align: center;
    /*padding-top: 1937px;*/
    
}
.muntitle{
    font-size:32px;
    font-family:Songti SC;
    font-weight:900;
    color:rgba(255,255,255,1);
    line-height:43px;
    text-shadow:0px 3px 8px rgba(255,117,131,0.3);
    padding:0 20px;
    vertical-align: middle;
}

.verticalalign-middle{
    vertical-align: middle;
}

.munbox{
    width:100%;
    background:#FFF7F5;
    border-radius:24px;
    padding:0 32px 60px;
    margin-bottom: 60px;

}


.munbox:last-child{
    margin-bottom: 0px;
}
.producttype{
    display:inline-block;
    width:178px;
    height:48px;
    line-height: 48px;
    color:#fff;
    font-size:24px;
    text-align:center;
    border-bottom-left-radius:42px;
    border-bottom-right-radius:42px;
    background: -webkit-linear-gradient(top, rgba(254,99,72,1), rgba(255,139,119,1));
    background: -o-linear-gradient(top, rgba(254,99,72,1), rgba(255,139,119,1));
    background: -moz-linear-gradient(top, rgba(254,99,72,1), rgba(255,139,119,1));
    background: -ms-linear-gradient(top, rgba(254,99,72,1), rgba(255,139,119,1));
    background: -webkit-gradient(linear, 0% 100%, from(rgba(254,99,72,1)), to(rgba(255,139,119,1)));
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgba(254,99,72,1)), color-stop(100%,rgba(255,139,119,1)));
    background:linear-gradient(0deg,rgba(254,99,72,1),rgba(255,139,119,1));
    box-shadow: 0px 0px  8px #FFAD9D;
}

.gradient{
    background: #000000;
    background: -moz-linear-gradient(top,  #000000 0%, #ffffff 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#000000), color-stop(100%,#ffffff));
    background: -webkit-linear-gradient(top,  #000000 0%,#ffffff 100%);
    background: -o-linear-gradient(top,  #000000 0%,#ffffff 100%);
    background: -ms-linear-gradient(top,  #000000 0%,#ffffff 100%);
    background: linear-gradient(to bottom,  #000000 0%,#ffffff 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#000000', endColorstr='#ffffff',GradientType=0 );
}
.dec{
    padding:24px 0;
    box-sizing:border-box;
    color:#444a46;
    font-size:24px;
    line-height: 24px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(80,79,75,1);
}

.dec-text{
    font-size:18px;
    color:#494947;
    line-height:30px;
    text-indent:3px;
    text-align:left;
    padding:20px 32px;
    background-color:#fff;
    border-radius:20px;
    position:relative;
    margin-bottom: 35px;
    
}
.tips{
    width: 174px;
    height:36px;
    line-height:36px;
    background-color:#45ccbe;
    box-sizing:border-box;
    position:absolute;
    bottom:-20px;
    right:0;
    border-bottom-right-radius:20px;
    border-top-left-radius:20px;
    text-align: center;
    
}
.tipstext{
    display:inline-block;
    font-size:24px;
    color:#fff;
    font-size:18px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(225,251,248,1);
}

.productdetailcontain{
    width: 273px;
    margin-right: 60px;
    display: inline-block;
    background-color: #fff;
    border-radius:24px;
    height: 402px;
    vertical-align: top;
    /*margin-bottom: 32px;*/
    cursor: pointer;
    padding:0 40px 0;
    box-sizing: border-box;
    box-shadow: 0px 0px 24px rgba(255,117,131,0.06);

}
.flex-container{
    display: flex;
    display: -webkit-box;
    display: -webkit-flex;
}

.productdetailcontain:nth-of-type(3n){
    margin-right: 0px;
}

.imgcontain{
    width:100%;
    height: 100%;
    display: inline-block;
    text-align:center;
    position: relative;
    overflow: hidden;
}
.center{
    position:absolute;
    left:50%;
    top:50%;
    transform: translate(-50%, -50%);
}
.greenfish{
    position:absolute;
    right:14px;
    bottom:0px;
}
.class1{
    height: 130%;
    /*width:238px;*/
}
.class2{
    height: 100%;
    /*width:120px;*/
}
.class3{
    height: 100%;
    /*width:157px;*/
}
.class4{
    /*width:218px;*/
    height: 114%;
}
.class5{
    /*width:140px;*/
    height: 100%;
}
.class6{
    /*width:106px;*/
    height: 100%;
}
.class7{
    /*width:119px;*/
    height: 100%;
}
.class8{
    /*width:200px;*/
    height: 100%;
}
.class9{
    /*width:200px;*/
    height: 120%;
}
.class10{
    /*width:210px;*/
    height: 120%;
}

.class11{
    /*width:82px;*/
    height: 100%;
}
.class12{
    /*width:110px;*/
    height: 100%;

}
.class13{
    /*width:172px;*/
    height: 100%;
}
.class14{
    /*width:128px;*/
    height: 100%;
}
.class15{
    /*width:76px;*/
    height: 100%;

}
.class16{
    /*width:158px;*/
    height: 112%;
}

.flex-one{
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
}
.brandcover{
    padding:20px 0 10px;
}

.band{
    
    font-size:24px;
    line-height: 26px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(80,79,75,1);
}

/*.title{
    font-size:18px;
    line-height: 24px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(80,79,75,1);
    padding-bottom: 20px;
}*/

.detail-tips{
    padding:0 12px;
    height:30px;
    background:rgba(210,242,238,1);
    border-radius:12px 0px 12px 0px;
    font-size:16px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(68,204,189,1);
    line-height: 30px;
    display:inline-block;
    text-align: center;

}
.address{
    padding-top: 16px;
    font-size:16px;
    line-height: 16px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(121,121,121,1);
}

.techcontain{
    width: 1054px;
    margin:0 auto;
    display: block;
    text-align: center;
}
.heightclass1{
    height: 392px;
}
.heightclass2{
    height: 392px;
    margin-right:0;
}
.heightclass3{
    height: 470px;
}

.flex-container{
    display: flex;
    display: -webkit-box;
    display: -webkit-flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    height: 256px;
}

.derection-column{
    flex-direction: column;
    -webkit-flex-direction: column;
}

.display_flex {
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
}

/*.display_flex > *{
     display: block;
 }*/
.display_inline-flex {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: -webkit-inline-flex;
    display: inline-flex;
}


/*伸縮流方向*/
.flex-direction_column {
    -webkit-box-orient: vertical;
    -ms-flex-direction: column;
    -webkit-flex-direction: column;
    flex-direction: column;
}

/*主軸對齊*/
.justify-content_flex-center {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
}

.justify-content_flex-end {
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    -webkit-justify-content: flex-end;
    justify-content: flex-end;
}

.justify-content_flex-justify {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
}

/*側軸對齊*/
.align-items_flex-start {
    -webkit-box-align: start;
    -ms-flex-align: start;
    -webkit-align-items: flex-start;
    align-items: flex-start;
}

.align-items_flex-end {
    -webkit-box-align: end;
    -ms-flex-align: end;
    -webkit-align-items: flex-end;
    align-items: flex-end;
}

.align-items_center {
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
}

.align-items_baseline {
    -webkit-box-align: baseline;
    -ms-flex-align: baseline;
    -webkit-align-items: baseline;
    align-items: baseline;
}

.align-items_space_between {
    -webkit-box-align: space-between;
    -ms-flex-align: space-between;
    -webkit-align-items: space-between;
    align-items: space-between;
}

.horizontal-between {
    justify-content: space-between;
    -webkit-justify-content: space-between;
}

/*伸縮性*/
.flex_auto {
    -webkit-box-flex: 1;
    -ms-flex: auto;
    -webkit-flex: auto;
    flex: auto;
}

.flex_1 {
    width: 0;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    -webkit-flex: 1;
    flex: 1;
}

.flex_2 {
    width: 0;
    -webkit-box-flex: 2;
    -ms-flex: 2;
    -webkit-flex: 2;
    flex: 2;
}


.flex-wrap_wrap {
    flex-wrap: wrap;
}
.padding-top-495 {
    padding-top: 495px;
}

.double11_head {
    width: 1000px;
    box-sizing: border-box;
    font-size: 26px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #FEAE50;
    line-height: 48px;

    background-color: #fff;
    text-align: center;
    letter-spacing: 2px;
    position: relative;
    z-index: 2;
    margin: 0 auto;
}

.double11_back {
    content: '';
    position: absolute;
    left: 50%;
    bottom: -14px;
    transform: translate(-50%, 0);
    width: 958px;
    height: 70px;
    background-image: url('http://p1.fishqc.net/Fnbl0MTCI_lcZufbh51TuOICg5-u');
    background-repeat: no-repeat;
    background-position: center center;

}

.font-weight-bold {
    font-weight: bold;


}

.padding-top-46 {
    padding-top: 46px;
    text-align: center;
}

.double11_desc1 {
    padding-top: 14px;
    font-size: 20px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #FFFFFF;
}

.double11_bg {
    width: 1078px;
    background-image: url('http://p1.fishqc.net/FrSI1Mebdl0WDMyxfdhmR0g89YMC');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
}

.double11_list {
    width: 1000px;
    margin-top: 82px;
    background-color: #fff;
    padding: 26px 30px 50px;
    box-sizing: border-box;
    z-index: 2;
    display: inline-block;
    position: relative;
}

.shadow-bottom {
    position: absolute;
    bottom: 30px;
    left: 0;
    z-index: 1
}

.double11_txt {
    font-size: 20px;
    font-family: Source Han Sans SC;
    font-weight: 300;
    color: #544F4D;
    text-align: center;
    line-height: 48px;
    text-align: left;
}

.double11_item {
    width: 454px;
    height: 161px;
    background: #FFFFFF;
    border: 1px solid #EEEAF0;
    margin-right: 27px;
    display: inline-block;
    margin-top: 20px;
    cursor: pointer;
}

.double11_item:nth-of-type(2n) {
    margin-right: 0;
}

.double11_item:nth-of-type(1) {
    margin-top: 6px;
}

.double11_item:nth-of-type(2) {
    margin-top: 6px;
}

.double11_list2 {
    margin-top: 92px;
    line-height: 48px;
    text-align: left;
}

.double11_list2 .double11_txt {
    text-align: left
}

.padding-top-110 {
    padding-top: 110px;
    text-align: center;
}

.double11_item_left {
    width: 160px;
    height: 100%;
    position: relative;
    display: inline-block;
    vertical-align: top;
}

.double11_item_left .productimg {
    width: 140px;
    position: absolute;
    left: 40%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.double11_item_right {
    width: 280px;
    height: 100%;
    display: inline-block;
    position: relative;
    padding-right: 20px;
    box-sizing: border-box;

}

.double11_item_right .title {
    padding-top: 25px;
    font-size: 20px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #3F3E3A;
    line-height: 30px;
    padding-bottom: 18px;
    text-align: left;
}

.double11_address {

    font-size: 17px;
    font-family: Source Han Sans SC;
    font-weight: 300;
    color: #666666;
    line-height: 17px;
}

.double11_label {
    width: 98px;
    height: 30px;
    background: #FDF2E3;
    text-align: center;
    line-height: 30px;

    font-size: 17px;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color: #FEAE82;
}

.greenfish {
    width: 64px;
    height: 64px;
    position: absolute;
    bottom: 10px;
    right: 10px;
}

.double_top_title {
    position: absolute;
    top: -52px;
    left: 50%;
    transform: translate(-50%, 0);
}
/**/
.descbox{
    height: 138px;
    background: #FFFFFF;
    box-shadow: 0px 0px 6px 4px #93eee0;
    border-radius: 24px;
    font-size: 24px;
    font-family: Source Han Sans SC;
    font-weight: 500;
    color: #3844BA;
    line-height: 44px;
    padding: 24px 130px 0 100px;
    box-sizing: border-box;
    text-align: left;
}

.padding_top_60{
    padding-top: 60px;
    box-sizing: border-box;
}

.typeItem{
    height: 138px;
    background: #355CD0;
    box-shadow: 0px 0px 6px 4px #93eee0;
    border-radius: 24px;
    font-size: 24px;
    font-family: Source Han Sans SC;
    font-weight: 500;
    color: #FEFFFF;
    line-height: 44px;
    text-align: left;
    padding:24px 116px 0 102px;
    box-sizing: border-box;
    position: relative;
}
.typeItem_bg{
    position: absolute;
    width:1116px;
    height: 121px;
    background: url('http://p1.fishqc.net/FgzbpmuZst-kw-yHrPcfK94rVFyt');
    background-size: contain;
    background-repeat: no-repeat;
    left: -56px;
    top: -78px;
}
    
.productItem_315{
    background: #EDFFFC;
    box-shadow: 0px 0px 8px 1px rgba(83, 116, 215, 0.29);
    border-radius: 24px;
    position: relative;
    margin-top: 78px;
    padding-top:52px;
    box-sizing: border-box;
    box-shadow: 0px 0px 12px 20px #24409314;
}

.productItem_type_title{
    width: 335px;
    height: 62px;
    background-image: url('http://p1.fishqc.net/FsFAr9gnZ3fl22TIaTazjL7T3LRS');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    line-height: 62px;
    text-align: center;
    position: absolute;
    left:50%;
    top:-31px;
    transform: translate(-50%,0);
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: 800;
    color: #3844BA;
}

.productItem_type_desc{
    width: 936px;
    margin:0 auto 30px;
    background: #FFFFFF;
    box-shadow: 0px 0px 9px 0px rgba(115, 228, 209, 0.21);
    border-radius: 16px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #3844BA;
    line-height: 30px;
    padding:18px 32px 14px;
    box-sizing: border-box;
    text-align: left;
    box-shadow: 0px 0px 12px 5px #73e4d12e;
}

.double12_product{
    width: 454px;
    height: 254px;
    background: #FFFFFF;
    box-shadow: 0px 1px 8px 0px rgba(205, 247, 218, 0.7);
    border-radius: 24px;
    cursor: pointer;
    box-shadow: 0px 0px 12px 5px #73e4d12e;
}

.double12_producttxt{
    font-size: 20px;
    font-family: Source Han Sans SC;
    font-weight: 500;
    color: #58BA96;
    text-align: left;
    padding-top: 40px;
    box-sizing: border-box;

    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #3844BA;
    line-height: 26px;
}

.double12_address{

    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #3844BA;
    line-height: 43px;
}

.double12_img{
    width: 154px;
    width: 200px;
    height: 254px;
    background-size: contain;
    background-repeat: no-repeat;
    position: relative;

}
.tips_padding{
    padding-top: 50px;
    padding-bottom: 24px;
    box-sizing: border-box;
}
.double12_tips{
    line-height: 16px;
    font-size: 16px;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color: #44CCBD;
    padding:6px 14px;
    box-sizing: border-box;
    background: #D2F2EE;
    opacity: 0.7;
    border-radius: 16px 0px 16px 0px;
    
}

.decclass{
    width: 880px;
}
.decclass1{
    width: 660px;
}
.greenfish{
    width: 88px;
    height: 88px;
    position: absolute;
    bottom: 24px;
    right: 0px;

}
.producttxt_name{
    font-size: 18px;
    line-height: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #3844BA;
    padding-top: 10px;
    box-sizing: border-box;
}

.product_img{
    width: 154px;
    height: 205px;
    margin-top: 30px;
    margin-left:20px;
    background-repeat: no-repeat;
    background-size: contain;
    position: relative;
}

/*315*/
.contain_2022_315{
    .title_315{
        width: 1048px;
        font-size: 34px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 56px;
        margin: 0 auto;
        padding-bottom: 90px;
        box-sizing: border-box;
    }

    .productcontain_315{
        width: 1128px;
        height: 591px;
        background: url('https://p1.fishqc.net/FpKU6ZUcyOBY9RJtdrIb6kpdC5RV') center center no-repeat;
        background-size: contain;
        padding: 0 34px;
        box-sizing: border-box;
    }

    .subtitle_315{
        padding-top: 48px;
        box-sizing: border-box;
        width: 1028px;
        font-size: 30px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 56px;
        margin: 0 auto;
    }

    .box_paddingtop{
        padding-top:64px;
        box-sizing: border-box;
        &:first-child{
            padding-top: 0;
        }
    }

    .title_3{
        font-size: 30px;
        font-family: PingFang SC;
        font-weight: 800;
        color: #FEFEFE;
        line-height: 70px;
        text-shadow: 1px 2px 3px #76AFC4;
        padding-top: 34px;
        box-sizing: border-box;
    }

    .producttype_desc{
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 44px;
        padding: 30px 30px 0px;
        box-sizing: border-box;
    }

    .productbox_315{
        width: 516px;
        height: 270px;
        background: #FFFFFF;
        border-radius: 24px;
        cursor: pointer;
        &.color1{
              background-color: #BFE8FD;
          }
          &.color2{
              background-color:#C9E6FB;
          }
          &.color3{
              background-color:#DEEAF9;
          }
          &.color4{
              background-color:#DEE0EF;
          }
          &.color5{
              background-color:#E8E4F1;
          }
          &.color6{
              background-color:#E9DFED;
          }
          &.height1{
            height: 294px;
          }
    }

    .padding_30_315{
        padding: 26px 30px;
        box-sizing: border-box;
    }
    .productImg{
        width: 278px;
        height: 100%;
        background-position: center center;
        background-size: 90%;
        background-repeat: no-repeat;
        position: relative;
        padding-left: 30px;
        box-sizing: border-box;
        .center{
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 30px;
        }
    }
    .productimage{

        background-position: center center;
        background-size: contain;
        background-repeat: no-repeat;
        /*&.class1{
            width: ;
            height: ;
        }
        &.class2{
            width: ;
            height: ;
        }
        &.class3{
            width: ;
            height: ;
        }
        &.class4{
            width: ;
            height: ;
        }
        &.class5{
            width: ;
            height: ;
        }

        &.class6{
            width: ;
            height: ;
        }
        &.class7{
            width: ;
            height: ;
        }
        &.class8{
            width: ;
            height: ;
        }
        &.class9{
            width: ;
            height: ;
        }
        &.class1{
            width: ;
            height: ;
        }*/
        
    }

    .brand_315{
        font-size: 24px;
        font-family: PingFang-SC-Medium;
        font-weight: 500;
        font-weight: 500;
        color: #504F4B;
        line-height: 24px;
        margin-top: 56px;
        box-sizing: border-box;
        background: linear-gradient(175deg, #425CB3 19.62890625%, #237CCD 72.8759765625%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        &.lineheight1{
            line-height: 28px;
        }
    }
    .producttitle_315{
        font-size: 18px;
        font-family: PingFang-SC-Regular;
        font-weight: 400;
        color: #504F4B;
        line-height: 18px;
        margin-top: 8px;
        background: linear-gradient(175deg, #425CB3 19.62890625%, #237CCD 72.8759765625%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        &.lineheight2{
            line-height: 22px;
        }
    }
    .tips_315{
        /*line-height: 16px;
        font-size: 16px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        background-color: #FFFCA0;
        padding:6px 14px;
        box-sizing: border-box;
        color: #FF7E00;
        opacity: 0.7;*/
        /*border-radius: 16px 0px 16px 0px;*/
        display: inline-block;
        height: 30px;
        line-height: 30px;
        background: linear-gradient(-90deg, #FFFBDB, #FDE9EC);
        border-radius: 15px 0px 15px 0px;
        padding: 0 15px;
        box-sizing: border-box;
        
    }
    .tips_text{
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #FFFFFF;

        background: linear-gradient(175deg, #425CB3 19.62890625%, #237CCD 72.8759765625%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;

    }
    .address_315{
        margin-top: 12px;
        box-sizing: border-box;
        
        line-height: 16px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #797979;

        background: linear-gradient(175deg, #425CB3 19.62890625%, #237CCD 72.8759765625%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .greenIcon{
        width: 88px;
        height: 88px;
        position: absolute;
        bottom:36px;
        right: 28px;
    }
}

.title_618{
    width: 1030px;
    font-size: 34px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 56px;

    background: linear-gradient(175deg, #2246BE 19.62890625%, #0771D2 72.8759765625%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin: 0 auto;
}

.top_box{
    width: 1056px;
    background: linear-gradient(-45deg, #78AFDC, #8DB7E9);
    box-shadow: 0px 8px 6px 1px rgba(34, 100, 174, 0.05);
    border-radius: 20px;
    display: inline-block;
    margin: 0 auto;
    position: relative;
}
.top_box_title{
    height: 62px;
    line-height: 62px;
    background: linear-gradient(-90deg, #FFFBDB, #FDE9EC);
    border-radius: 0px 0px 50px 50px;
    display: inline-block;
    padding: 0 54px;
    box-sizing: border-box;
    .title{
        font-size: 32px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #FFFFFF;
        background: linear-gradient(175deg, #425CB3 19.62890625%, #237CCD 72.8759765625%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
}

.top_box_desc{
    width: 970px;
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 48px;
    margin: 0 auto;
    text-align: left;
    padding: 26px 0 20px;
    box-sizing: border-box;
}

.padding_134{
    padding-top: 134px;
    box-sizing: border-box;
}
.padding_300{
    padding-top: 300px;
    box-sizing: border-box;
}
.icon1{
    position: absolute;
    width: 252px;
    height: 56px;
    background: url('https://p1.fishqc.net/FukYv356ND4__Z_fWwOPmKQFLI0K') center center;
    background-size: contain;
    left:0 ;
    top: -56px;
}
.icon2{
    position: absolute;
    width: 252px;
    height: 56px;
    background: url('https://p1.fishqc.net/FnzP3HNDLgr4KHQY_--fIwfGUrPD') center center;
    background-size: contain;
    right:0 ;
    top: -56px;
}
.icon3{
    position: absolute;
    width: 252px;
    height: 57px;
    background: url('https://p1.fishqc.net/Fp24eiWjqtJcGZmZPdg7cpyJj9Iw') center center;
    background-size: contain;
    left:0 ;
    top: -56px;
}

.itemtitle{
    height: 50px;
    line-height: 50px;
    background: linear-gradient(-33deg, #C481A4, #347AB6);
    border-radius: 0px 30px 0px 0px;
    padding: 0 36px 0 30px;
    box-sizing: border-box;
    font-size: 28px;

font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFE;
    display: inline-block;
}

.margin_top_32{
    margin-top: 32px;
    
}
.subbox{
    width: 1056px;
    background: #FFFFFF;
    border-radius: 0px 20px 20px 20px;
    padding: 26px 32px 28px;
    box-sizing: border-box;
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #0A86CD;
    line-height: 48px;
}

.padding_top_24{
    padding-top: 24px;
    box-sizing: border-box;
}
</style>
<script>
import Vue from 'vue'
// @ is an alias to /src
import banner from '@/components/banner.vue'
import { myMixin } from '@/mixin/mixin.js'
export default {
    name: 'about',
    components: {
        banner,
    },
    mixins: [myMixin],
    data() {
        return {
            productdata: [
                {
                    title:'美妆护肤优品',
                    dec: '今年第一个剁手节，美妆护肤品必须囤起来！劣质产品影响颜值更伤害身体，认准科学测评的绿鱼优品。',
                    img:'https://p1.fishqc.net/FtekH2MNU-DdM0SryhrZYljZ6YSQ',
                    paddingtop:'padding_134',
                    bgicon:"icon1",
                    class:'',
                    dd: {
                        '1': {
                            destext: '精华所富含的营养物质和活性物都高于普通护肤品,功能性更强。选择精华除了根据皮肤的需求，更要选择安全优品。',
                            // destext1: '在皮肤表面形成一层保护膜，减缓肌肤水分的流失。',
                            title: '精华',
                            paddingtop60:'',
                            product: [{
                                img: 'https://p1.fishqc.net/FkZ7T5uD666TxOjvIWfd-h321ih_',
                                class: 'class1',
                                brand: "PURID",
                                title: '先研净肤精华液',
                                tips: '净透毛孔',
                                address: '中国',
                                type: 'cosmetic',
                                id: '_dwf5H2duk1spkK_iJXzOQ',
                                height: 'heightclass1',
                                showgreen:true,
                                // effencyimgshow:true,
                                // effencyimg:'https://p1.fishqc.net/Fof13MBzKi-YsaRGkC5x8NLs6H-m',
                                paddingclass:'padding_bottom_6',
                                boxbgColor:'color1'
        
                            }, {
                                img: 'https://p1.fishqc.net/FoeMTeXeJmxYlc9bpu7NKk47PXnD',
                                class: 'class2',
                                brand: 'OLAY玉兰油',
                                title: '纯璨晶透肌底精华露',
                                tips: '全能流光瓶',
                                address: '美国',
                                type: 'cosmetic',
                                id: 'Mga3kkvuyAkz8jNtxqoZTQ',
                                height: 'heightclass1',
                                showgreen:true,
                                paddingclass:'padding_bottom_22',
                                boxbgColor:'color1'
                            }]
                        },
                        '2': {
                            destext: '乳液相较面霜含水量更高，适合夏季及油性皮肤使用。安全乳液优品可以清除污垢，补水锁水以及滋养皮肤。',
                            title: '乳液',
                            // destext1: '才能锁住水份，在皮肤表层形成保护作用。',
                            paddingtop60:'paddingtop60',
                            product: [{
                                img: 'https://p1.fishqc.net/FnRyINhBI89qSVrGrx9cBEzrkX3P',
                                class: 'class3',
                                brand: "EAU THERMALE<br> AVENE雅漾",
                                title: '高效抗敏舒缓保湿乳',
                                tips: '舒缓维稳',
                                address: '法国',
                                type: 'cosmetic',
                                id: 'vawwnwDwvEzAbIO1K5uG-g',
                                height: 'heightclass1',
                                showgreen:true,
                                paddingclass:'padding_bottom_22',
                                boxbgColor:'color1',
                                brandshow:true
        
                            }, {
                                img: 'https://p1.fishqc.net/FiUnX_pl7G07z46zfsX72ie7ItUF',
                                class: 'class4',
                                brand: "MUJI无印良品",
                                title: '基础润肤乳液 高保湿型',
                                tips: '强效保湿',
                                address: '日本',
                                type: 'cosmetic',
                                id: 'igxZpnpfFnfefQrVXtU5Yw',
                                height: 'heightclass1',
                                showgreen:true,
                                paddingclass:'padding_bottom_22',
                                boxbgColor:'color1'
                            }]
                        },
                        '3': {
                            destext: '神仙色号千千万，安全第一位。劣质口红成分复杂，容易诱发过敏甚至炎症，安全口红才是第一选择。',
                            title: '口红',
                            // destext1: '需要选择合适的眼霜，缓解眼部皮肤问题。',
                            paddingtop60:'paddingtop60',
                            product: [{
                                img: 'https://p1.fishqc.net/FlL-QeVu3sl9jllgyAJJzMyXNMYk',
                                class: 'class5',
                                brand: "CHANEL香奈儿",
                                title: '魅力炫光唇釉<br>(80 Timeless)',
                                tips: '高级显色',
                                address: '法国',
                                type: 'cosmetic',
                                id: '7q40WmzzMLTQxHo2FMMsKQ',
                                height: 'heightclass1',
                                showgreen:true,
                                paddingclass:'padding_bottom_22',
                                boxbgColor:'color1',
                                titleshow:true
        
                            }, {
                                img: 'https://p1.fishqc.net/Ft0QCMqk3M4uB5ZjcjYDb1gNuR7S',
                                class: 'class6',
                                brand: 'LANCOME兰蔻',
                                title: '菁纯柔雾哑光唇膏 <br>(888 小野莓)',
                                tips: '持久滋润',
                                address: '法国',
                                type: 'cosmetic',
                                id: '9dr3BLU_d56XBHfFCXDxYA',
                                height: 'heightclass1',
                                showgreen:true,
                                paddingclass:'padding_bottom_22',
                                boxbgColor:'color1',
                                titleshow:true
                            }]
                        },
        
                    },
                },
                {
                    title:'食品饮料优品',
                    dec: '618必剁手的肯定少不了吃吃喝喝的，要喝到嘴里吃进肚子，更要选择经过科学测评的绿鱼优品。',
                    img:'https://p1.fishqc.net/FgEpyZgWfkS8Z3dOFjbtKLU6OASc',
                    class:'padding_top_50',
                    paddingtop:'padding_300',
                    bgicon:"icon2",
                    dd: {
                        '1': {
                            destext: '护肤可不止靠外用，内调可不能忽视。科学测评内服美肤优品，内调外养，健康好肌肤吃出来。',
                            // destext1: '在皮肤表面形成一层保护膜，减缓肌肤水分的流失。',
                            title: '美肌食品',
                            paddingtop60:'',
                            product: [{
                                img: 'https://p1.fishqc.net/FjudWTc8fGWkODllSB3gbWoL69uu',
                                class: 'class7',
                                brand: "MARUBI丸美®",
                                title: '复合肽红参燕窝肽饮品',
                                tips: '养颜养气色',
                                address: '中国',
                                type: 'food',
                                id: '_s7rQ5nI87BRu3GxgO9vCg',
                                height: 'heightclass1',
                                showgreen:true,
                                // effencyimgshow:true,
                                // effencyimg:'https://p1.fishqc.net/Fspqw91DIo7FAgveQSC6wCwmKg4X',
                                paddingclass:'padding_bottom_6',
                                boxbgColor:'color2'
                                // class:'effency2'
        
                            }, {
                                img: 'https://p1.fishqc.net/FiA7ZMpGqSvVvZPyZG5NHparL3NN',
                                class: 'class8',
                                brand: 'FANCL芳珂',
                                title: '透亮美肌营养素(片剂)',
                                tips: '亮白光泽',
                                address: '日本',
                                type: 'food',
                                id: '0QT86UqXRI8JN_MhuSjT3Q',
                                height: 'heightclass1',
                                showgreen:true,
                                // effencyimgshow:true,
                                // effencyimg:'https://p1.fishqc.net/FvIrTZXik6S4tJoPMcABBgZd8Xu-',
                                paddingclass:'padding_bottom_6',
                                // class:'effency3',
                                boxbgColor:'color2'
                            }]
                        },
                        '2': {
                            destext: '小鱼数据库中，大部分不达标零食产品均是类雌激素过高，容易导致性早熟，智商降低，癌症等，安全优品才放心。',
                            title: '健康软糖',
                            // destext1: '才能锁住水份，在皮肤表层形成保护作用。',
                            paddingtop60:'paddingtop60',
                            product: [{
                                img: 'https://p1.fishqc.net/Frq4cRr8EKXlmNSSvuRnztNXn8co',
                                class: 'class9',
                                brand: "HARIBO哈瑞宝",
                                title: '可乐软糖',
                                tips: '网红软糖',
                                address: '德国',
                                type: 'food',
                                id: 'a5J-zI2z4X_GhIWCNo5eBg',
                                height: 'heightclass1',
                                showgreen:true,
                                paddingclass:'padding_bottom_22',
                                boxbgColor:'color2'
        
                            }, {
                                img: 'https://p1.fishqc.net/FqA81O0X21IwJbBSmbKfR5M_QnIs',
                                class: 'class10',
                                brand: 'MEIJI明治',
                                title: '果汁橡皮糖提子味',
                                tips: 'Q弹可口',
                                address: '日本',
                                type: 'food',
                                id: 'UGXkPRaGmSWoZCEiVFGbrQ',
                                height: 'heightclass1',
                                showgreen:true,
                                paddingclass:'padding_bottom_22',
                                boxbgColor:'color2'
                            }]
                        },
                        '3': {
                            destext: '夏天的快乐是冰冻快乐水带来的，但很多功能饮料中的劣质添加剂过多，容易影响身体健康，囤安全快乐水更快乐。',
                            title: '功能饮料',
                            // destext1: '需要选择合适的眼霜，缓解眼部皮肤问题。',
                            paddingtop60:'paddingtop60',
                            product: [{
                                img: 'https://p1.fishqc.net/FgNWQeRPj_3rNdxOOw6xfVn4aiFJ',
                                class: 'class11',
                                brand: "NONG FU农夫山泉",
                                title: '力量帝柠檬风味维他命水',
                                tips: '补充维他命',
                                address: '中国',
                                type: 'food',
                                id: 'p8RlVc0peip3pHNN72Ov2Q',
                                height: 'heightclass1',
                                showgreen:true,
                                paddingclass:'padding_bottom_22',
                                boxbgColor:'color3'
        
                            }, {
                                img: 'https://p1.fishqc.net/FsDWpT8j9udUo2tM0SO3NbHsFWsl',
                                class: 'class12',
                                brand: 'EASTROC东鹏',
                                title: '特饮维生素功能饮料',
                                tips: '提神抗疲劳',
                                address: '中国',
                                type: 'food',
                                id: '_vzPRC-YUrDiF26pqjMrSw',
                                height: 'heightclass1',
                                showgreen:true,
                                paddingclass:'padding_bottom_22',
                                boxbgColor:'color3'
                            }]
                        }
                        
        
                    }
                },{
                    title:'生活日用优品',
                    dec: '消耗量大的生活日用品618也要安排上，夏天就要备上清清爽爽的生活日用好物，安心又舒心。',
                    img:'https://p1.fishqc.net/FllzGVH_qfWadf0O_vKdv6d9myTp',
                    class:'padding_top_50',
                    paddingtop:'padding_300',
                    bgicon:"icon3",
                    dd: {
                        '1': {
                            destext: '劣质洗发水不仅会使头发干枯易断无光泽，更会造成皮肤过敏、脱发等。安全优品让你的夏日清爽从头开始。',
                            // destext1: '在皮肤表面形成一层保护膜，减缓肌肤水分的流失。',
                            title: '洗发水',
                            paddingtop60:'',
                            product: [{
                                img: 'https://p1.fishqc.net/FnZ0CPXBczxMWo7xpE5Myp8Qm4lo',
                                class: 'class13',
                                brand: "L'OREAL PARIS<br>巴黎欧莱雅",
                                title: '玻尿酸水光洗发水露',
                                tips: '清爽蓬松',
                                address: '法国',
                                type: 'cosmetic',
                                id: 'lFOz66xC5jt7Ui_ba28-7Q',
                                height: 'heightclass1',
                                showgreen:true,
                                paddingclass:'padding_bottom_22',
                                boxbgColor:'color4',
                                brandshow:true
        
                            }, {
                                img: 'https://p1.fishqc.net/Fow3wD94YkYahTeATV4fxuxqu8D0',
                                class: 'class14',
                                brand: 'AQUAIR水之密语',
                                title: '凈澄水活洗发露',
                                tips: '柔顺滋润',
                                address: '日本',
                                type: 'cosmetic',
                                id: 'QZAwyPOKdqsoQnqfALi9jg',
                                height: 'heightclass1',
                                showgreen:true,
                                paddingclass:'padding_bottom_22',
                                boxbgColor:'color4'
                            }]
                        },
                        '2': {
                            destext: '每日使用的沐浴露更要安排安全优品，劣质沐浴露不仅会伤害皮肤角质层，还可能引起过敏，严重的还可能致癌。',
                            title: '沐浴露',
                            // destext1: '才能锁住水份，在皮肤表层形成保护作用。',
                            paddingtop60:'paddingtop60',
                            product: [{
                                img: 'https://p1.fishqc.net/FiE9bkj3-mgEH-C954J8_DeYLAIc',
                                class: 'class15',
                                brand: "La Roche-Posay<br>理肤泉",
                                title: '全效抗敏修護沐浴乳<br>(止痕配方)',
                                tips: '温和洁净',
                                address: '法国',
                                type: 'cosmetic',
                                id: 'rIl-8WxuTasq9ITI1n5k3Q',
                                height: 'heightclass1',
                                showgreen:true,
                                paddingclass:'padding_bottom_22',
                                boxbgColor:'color5',
                                brandshow:true,
                                titleshow:true,
                                highheight:'height1'
        
        
                            }, {
                                img: 'https://p1.fishqc.net/FqaVjl2q9aIhg2sy4OCRIqw9V-X2',
                                class: 'class16',
                                brand: 'JURLIQUE',
                                title: '玫瑰緻柔沐浴露',
                                tips: '甜香润泽',
                                address: '澳大利亚',
                                type: 'cosmetic',
                                id: '-7qPNDOExtw8u3nMqLXTMg',
                                height: 'heightclass1',
                                showgreen:true,
                                paddingclass:'padding_bottom_22',
                                boxbgColor:'color5',
                                highheight:'height1'
                            }]
                        },
                        '3': {
                            destext: '止汗剂可以减少流到皮肤表面的汗量，并抑制引起体味的细菌繁殖，夏季必备更要囤安全好用的。',
                            title: '止汗剂',
                            // destext1: '才能锁住水份，在皮肤表层形成保护作用。',
                            paddingtop60:'paddingtop60',
                            product: [{
                                img: 'https://p1.fishqc.net/FoDiyj8YEfwFn82w1Fpws8Cd04vE',
                                class: 'class17',
                                brand: "NIVEA妮维雅",
                                title: '净白止汗走珠',
                                tips: '止汗抑臭',
                                address: '德国',
                                type: 'cosmetic',
                                id: 'nanZ2t0jFFnqLiCGrFQwuQ',
                                height: 'heightclass1',
                                showgreen:true,
                                paddingclass:'padding_bottom_22',
                                boxbgColor:'color6'
                                    
                                    
                            }, {
                                img: 'https://p1.fishqc.net/FtUpj4eYRwU1paVE7KHwnBlcHcIb',
                                class: 'class18',
                                brand: 'DOVE多芬',
                                title: '低敏无香止汗走珠香体露',
                                tips: '清爽淡雅',
                                address: '美国',
                                type: 'cosmetic',
                                id: 'lrc8SHVo1YZHTfqxTyqzRg',
                                height: 'heightclass1',
                                showgreen:true,
                                paddingclass:'padding_bottom_22',
                                boxbgColor:'color6'
                            }]
                        }
        
                    }
                }
                
        
            ]
            // productDatas:[
            //     {
            //         titleImg:'https://p1.fishqc.net/FoboqaO_JCEAAmIuprhtOWMXyoq2',
            //         desc:'女生们最关心的是护肤品的安全了，天天使用稍有不慎伤害皮肤又影响身体健康，认准绿鱼，美得放心。',
            //         productarr:[
            //             {
            //                 title:'精华',
            //                 desc:'精华液中的营养物质能够由肌肤表面进入到肌肤的基底层，发挥作用。根据皮肤的需求选择合适安全的精华极其重要。',
            //                 product:[{
            //                     img: 'https://p1.fishqc.net/FuDfpDVvrmbYukMFXuxtOt7Jynyk',
            //                     brand: "PURID 朴理",
            //                     title: '2号创研修护焕漾二号精华液',
            //                     tips: '抗红御氧',
            //                     address: '中国',
            //                     type: 'cosmetic',
            //                     id: 'uBKKOZ0Ao5UKRKyj9CEC6g',
            //                     effect:true
                      
            //                 },{
            //                     img: 'https://p1.fishqc.net/FoPiuShmnjkBCr4gz9DGlWVaTYbt',
            //                     brand: "DECORTE黛珂",
            //                     title: '莹润粹白璇亮菁华液',
            //                     tips: '匀白透亮',
            //                     address: '日本',
            //                     type: 'cosmetic',
            //                     id: 'h5LBDZFWWgR7W287E052Wg',
                      
            //                 }]
            //             },{
            //                 title:'爽肤水',
            //                 desc:'爽肤水浸润调理角质层，使肌肤更好地吸收后续的保养品，打好保养护肤的基础更要选择安全的爽肤水产品。',
            //                 product:[{
            //                     img: 'https://p1.fishqc.net/FkTBDX2JTSlNI1gwH1AbleE8rwZV',
            //                     brand: "My Clorisland 花皙蔻",
            //                     title: ' 洛神花细致毛孔精华水',
            //                     tips: '混油皮必备',
            //                     address: '中国',
            //                     type: 'cosmetic',
            //                     id: 'BgdaLLepToHrcHu00hNxTg',
                      
            //                 },{
            //                     img: 'https://p1.fishqc.net/FoX8BUTUHesQkfV7tV3NLAu1NpG0',
            //                     brand: "IPSA茵芙莎 ",
            //                     title: '流金岁月凝润美肤水',
            //                     tips: '保湿净白',
            //                     address: '日本',
            //                     type: 'cosmetic',
            //                     id: 'MJuXaYg7_IxfTpA-NDtfEA',
                      
            //                 }]
            //             },{
            //                 title:'防晒',
            //                 desc:'日晒与紫外线，不仅会引起皮肤损伤，黑色素沉着，更重要是使皮肤老化。选择安全的绿鱼防晒更安心。',
            //                 product:[{
            //                     img: 'https://p1.fishqc.net/FrAHKukH-vRHCeOpCSDxFrvpADfJ',
            //                     brand: "DECORTE黛珂 ",
            //                     title: '多重防晒乳',
            //                     tips: '高倍防晒',
            //                     address: '日本',
            //                     type: 'cosmetic',
            //                     id: 'b64OKxCsDJ_HEfG3t5woQg',
                      
            //                 },{
            //                     img: 'https://p1.fishqc.net/FkP4KpUA_dpAecGoqBF38JlFVI8C',
            //                     brand: "NIVEA妮维雅",
            //                     title: '水感防日光保湿啫喱<br>SPF50 PA+++',
            //                     tips: '平价大碗',
            //                     address: '德国',
            //                     type: 'cosmetic',
            //                     id: 'H1RwxIoptj0LO0Tiasdtbg',
            //                 }]
            //             }
            //         ]

            //     },
            //     {
            //         titleImg:'https://p1.fishqc.net/FtR6Z9CKXuFq0eGvCPZyRdEcyXYz',
            //         desc:'母婴用品曝光的安全问题屡见不鲜，孕妈和孩子的用品更要选择安全好物，才能安心每一天。',
            //         productarr:[
            //             {
            //                 title:'孕妇保健品',
            //                 desc:'各种孕期产品鱼龙混杂，孕期营养更需慎重，某些劣质营养素可能会危害胎儿和妈妈的健康，跟着绿鱼榜单选，全家安心。',
            //                 product:[{
            //                     img: 'https://p1.fishqc.net/FuDbfEpxBs2FQewuVfTavARJZV5h',
            //                     brand: "BLACKMORES澳佳宝",
            //                     title: '孕妇黃金营养素',
            //                     tips: '营养丰富',
            //                     address: '澳大利亚',
            //                     type: 'food',
            //                     id: 'cW_N74C4g-mLLUkKwhq9vw',
                      
            //                 },{
            //                     img: 'https://p1.fishqc.net/FrWYPomo8XnXMbJZxm544Lrtmp74',
            //                     brand: "GNC健安喜",
            //                     title: '孕妇营养包含维生素+钙+DHA<br>全面综合营养30天配方 - 钙',
            //                     tips: '高含量钙',
            //                     address: '美国',
            //                     type: 'food',
            //                     id: '5xjBClrf0YW4FolgC34zMg',
            //                 }]
            //             },{
            //                 title:'儿童牙膏',
            //                 desc:'不同于成人刷牙只需清洁到位，宝宝刷牙容易吞咽牙膏，选择成分安全的儿童牙膏就至关重要，看准好物榜单不踩雷。',
            //                 product:[{
            //                     img: 'https://p1.fishqc.net/FqOkMifjLAPRGIt04CujX6O3Zlez',
            //                     brand: "INTELLIGENT因特力净",
            //                     title: '儿童酵素牙膏',
            //                     tips: '酵素洁净',
            //                     address: '中国台湾',
            //                     type: 'cosmetic',
            //                     id: 'JSnuGpfbq0FTPOGhm8AolQ',
                      
            //                 },{
            //                     img: 'https://p1.fishqc.net/FhfXyKUEu1QbmLuwjkFKCufegrpF',
            //                     brand: "PIGEON贝亲",
            //                     title: '婴儿防蛀牙膏(木糖醇口味)',
            //                     tips: '防龋固齿',
            //                     address: '日本',
            //                     type: 'cosmetic',
            //                     id: 'j4uzKG8E1EV36guypo-kMw',
            //                 }]
            //             },{
            //                 title:'儿童零食',
            //                 desc:'小鱼数据库中，大部分不达标零食产品均是类雌激素过高，容易导致性早熟，智商降低，癌症等，选绿鱼优品才放心。',
            //                 product:[{
            //                     img: 'https://p1.fishqc.net/FoB1Pzw9BfXgiP9ayzg4kJGsd9h0',
            //                     brand: "SUNRYPE",
            //                     title: '果肉水果条 72条',
            //                     tips: '营养美味',
            //                     address: '加拿大',
            //                     type: 'food',
            //                     id: 'Yxh79H1iSWh7qzqBiYeNoA',
                      
            //                 },{
            //                     img: 'https://p1.fishqc.net/FnqfwSD0BhOrBYqLGZZN0hfFQl9_',
            //                     brand: "HEINZ亨氏",
            //                     title: '谷物磨牙棒（香橙/蔬菜/牛奶）',
            //                     tips: '纯净天然',
            //                     address: '美国',
            //                     type: 'food',
            //                     id: 'J0sLDQPzNwlOwbxwCn71Yw',
            //                 }]
            //             }
            //         ]

            //     },
            //     {
            //         titleImg:'https://p1.fishqc.net/FkV4KlepYBgF2BEYYRagdwHz8YL-',
            //         desc:'日用品安全也是需要关注的重要一环，每天都使用的日用品当然要安全才更安心。',
            //         productarr:[
            //             {
            //                 title:'驱蚊水',
            //                 desc:'天气转热蚊虫增多，驱蚊水必不可少，但劣质驱蚊水含有害成分，可能会有致畸、 致突变等危害，选择安全产品很重要。',
            //                 product:[{
            //                     img: 'https://p1.fishqc.net/Fgj2Fu0DK_-4iU_tGTP9N0_m-_wv',
            //                     brand: "CHICCO智高",
            //                     title: '婴儿防蚊喷雾',
            //                     tips: '温和驱蚊',
            //                     address: '意大利',
            //                     type: 'cosmetic',
            //                     id: 'vfEaKQp6pQqg5qa4Drc1pw',
                      
            //                 },{
            //                     img: 'https://p1.fishqc.net/FiWNNlPovMAMKGYddKG8rVGL7TRp',
            //                     brand: "AEROGARD",
            //                     title: '防蚊水喷雾驱蚊液',
            //                     tips: '长效驱蚊',
            //                     address: '英国',
            //                     type: 'cosmetic',
            //                     id: '_pO7XJ-QM3WvhYz_PtCYXw',
            //                 }]
            //             },{
            //                 title:'搓手液',
            //                 desc:'搓手液不离手的现在，劣质搓手液会让皮肤变得干燥、过敏甚至可能引起接触性皮肤炎，保护家人健康，选择安心搓手液。',
            //                 product:[{
            //                     img: 'https://p1.fishqc.net/FlXRlZPfRp4Pzw0X6Wyz96tIULjy',
            //                     brand: "SAFEGUARD舒肤佳",
            //                     title: '抑菌免洗洗手液',
            //                     tips: '有效抑菌',
            //                     address: '美国',
            //                     type: 'cosmetic',
            //                     id: 'mIgBen-ZvNrHEIza7ly7hQ',
                      
            //                 },{
            //                     img: 'https://p1.fishqc.net/Fqddb1Y42hJzNzU4l74TMI2CA0H0',
            //                     brand: "DETTOL滴露",
            //                     title: '酒精搓手液 经典松木',
            //                     tips: '免洗除菌',
            //                     address: '英国',
            //                     type: 'cosmetic',
            //                     id: 'xLdMebptwiqp_bR7Gu7n1g',
            //                 }]
            //             },{
            //                 title:'湿纸巾',
            //                 desc:'疫情时代，湿纸巾用处多多，但湿纸巾含有毒成分的新闻屡见不鲜，挑选安全湿纸巾更是重中之重。',
            //                 product:[{
            //                     img: 'https://p1.fishqc.net/FoWg7wDRSzcn6e5bLxgQXJ3CPSIt',
            //                     brand: "MANNINGS万宁 ",
            //                     title: '抗菌湿巾 (无香味)',
            //                     tips: '杀菌清洁',
            //                     address: '中国香港',
            //                     type: 'cosmetic',
            //                     id: 'Mu08gZ5iqJIirxOugaJ2kw',
                      
            //                 },{
            //                     img: 'https://p1.fishqc.net/Fk00xVzRjlSEI_QpIKItAI-jiotm',
            //                     brand: "RUNBEN润本 ",
            //                     title: '卫生湿巾',
            //                     tips: '双重杀菌',
            //                     address: '中国',
            //                     type: 'cosmetic',
            //                     id: 'fn3u3-JcN_ZXmpIMq5-oQg',
            //                 }]
            //             }
            //         ]
            //     },
            // ]
        }

    },
    computed: {
        swiper() {
            return this.$refs.order_report_Swiper.$swiper
        }
    },
    mounted() {
        // var position  =  this.$route.query.position
        // this.scrollTo(position)
        this.currentlang = window.localStorage.getItem("LOCALE") || 'chs'
    },
    methods: {
        scrollTo(position) {
            var that = this;
            var scroll_H;
            this.$nextTick(function() {
                if (position == 'greenrank') {
                    var d = document.getElementById("greenrank");
                    var topPos = d.offsetTop;
                    scroll_H = topPos - 110; //减去header高度
                } else {
                    scroll_H = this.$refs[position].offsetTop - 110; //减去header高度
                }
                //全局方法
                that.scrollToY(scroll_H, 1500, 'easeInOutQuint');
            })
        },
        toproductdetail(type,prdid){
            let routeUrl  =this.$router.resolve({
                path:'/product',
                // query:{
                //     type:prdid
                // }
            })

            console.log(routeUrl.href)
            // return

            window.open(routeUrl.href+'/'+type+'/'+prdid,'_blank')


            // this.$router.push({
            //     path: '/product/'+type+'/'+prdid
            // / })
            
        }
    }
}
</script>